export enum ExternalSalaryTypeSystem {
APD,
AADE,
AADE_BUSINESS,
AADE_DIVIDENT,
}
